// deno-fmt-ignore-file
export function FromObject(properties) {
    return properties;
}
